import "isomorphic-fetch";

const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";


const requestData = () => ({ type: FETCH_DATA_REQUEST });
const receivedData = initialData => ({ type: FETCH_DATA_SUCCESS, payload: initialData });
const dataError = () => ({ type: FETCH_DATA_FAILURE, payload: "data error" });

// Reducer
export default function reducer(state = {}, action) {
    switch (action.type) {
        case FETCH_DATA_SUCCESS:
            return { ...state, initialData: action.payload };

        case FETCH_DATA_FAILURE:
            return { ...state, error: true };    

        default:
            return state;
    }
}

export const fetchInitialDataGET = (url, header) => (dispatch, getState) => {
    dispatch(requestData());
    return fetch(url, {
        method: 'GET',
        headers: JSON.parse(header)
    }).then(response => response.json())
        .then(initialData => dispatch(receivedData(initialData)))
        .catch(err => dispatch(dataError(err)));
};

// export const fetchInitialData = (url, header, body) => (dispatch, getState) => {
//     console.log("request data : ", body);
//     dispatch(requestData());
//     return fetch(url, {
//         method: 'POST',
//         body: body,
//         headers: JSON.parse(header)
//     }).then(response => response.json())
//         .then(initialData => dispatch(receivedData(initialData)))
//         .catch(err => dispatch(dataError(err)));
// };
export const fetchInitialData = (url, header, body) => (dispatch, getState) => {
    console.log("📤 [fetchInitialData] Request initiated");
    console.log("➡️ URL:", url);
    console.log("➡️ Headers:", header);
    console.log("➡️ Body:", body);

    dispatch(requestData());
    console.log("✅ [fetchInitialData] requestData dispatched");

    return fetch(url, {
        method: 'POST',
        body: body,
        headers: JSON.parse(header)
    })
        .then(response => {
            console.log("📥 [fetchInitialData] Raw response:", response);
            return response.json();
        })
        .then(initialData => {
            console.log("📦 [fetchInitialData] Parsed response JSON:", initialData);
            dispatch(receivedData(initialData));
            console.log("✅ [fetchInitialData] receivedData dispatched");
            return initialData; // return so caller can use it if needed
        })
        .catch(err => {
            console.error("❌ [fetchInitialData] Error occurred:", err);
            dispatch(dataError(err));
        });
};


export const fetchInitialData2 = (obj1, obj2, header) => (dispatch, getState) => {
    console.log("request data 1 : ", obj1.body);
    console.log("request data 2 : ", obj2.body);
    dispatch(requestData());
    return Promise.all([
        fetch(obj1.url, {
            method: 'POST',
            body: obj1.body,
            headers: JSON.parse(header)
        }),
        fetch(obj2.url, {
            method: 'POST',
            body: obj2.body,
            headers: JSON.parse(header)
        })
    ]).then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
        .then(([data1, data2]) => {
            let initialData = {};
            initialData['data1'] = data1;
            initialData['data2'] = data2;
            dispatch(receivedData(initialData))
        }).catch(err => dispatch(dataError(err)));
};

export const fetchInitialData3 = (obj1, obj2, obj3, header) => (dispatch, getState) => {
    console.log("request data 1 : ", obj1.body);
    console.log("request data 2 : ", obj2.body);
    console.log("request data 3 : ", obj3.body);
    dispatch(requestData());
    return Promise.all([
        fetch(obj1.url, {
            method: 'POST',
            body: obj1.body,
            headers: JSON.parse(header)
        }),
        fetch(obj2.url, {
            method: 'POST',
            body: obj2.body,
            headers: JSON.parse(header)
        }),
        fetch(obj3.url, {
            method: 'POST',
            body: obj3.body,
            headers: JSON.parse(header)
        })
    ]).then(([res1, res2, res3]) => Promise.all([res1.json(), res2.json(), res3.json()]))
        .then(([data1, data2, data3]) => {
            console.log("data1 ===>",data1)
            console.log("data2 ===>",data2)
            console.log("data3 ===>",data3)

            let initialData = {};
            initialData['data1'] = data1;
            initialData['data2'] = data2;
            initialData['data3'] = data3;
            dispatch(receivedData(initialData))
        }).catch(err => dispatch(dataError(err)));
};

export const fetchInitialData4 = (obj1, obj2, obj3, obj4, header) => (dispatch, getState) => {
    console.log("request data 1 fetchInitialData4 : ", obj1);
    console.log("request data 2 fetchInitialData4 : ", obj2);
    console.log("request data 3 fetchInitialData4 : ", obj3);
    console.log("request data 4 fetchInitialData4 : ", obj4);
    console.log("request api 4 fetchInitialData4 header : ", JSON.parse(header));
    dispatch(requestData());
    return Promise.all([
        fetch(obj1.url, {
            method: 'POST',
            body: obj1.body,
            headers: JSON.parse(header)
        }),
        fetch(obj2.url, {
            method: 'POST',
            body: obj2.body,
            headers: JSON.parse(header)
        }),
        fetch(obj3.url, {
            method: 'POST',
            body: obj3.body,
            headers: JSON.parse(header)
        }),
        fetch(obj4.url, {
            method: 'POST',
            body: obj4.body,
            headers: JSON.parse(header)
        })
    ]).then(([res1, res2, res3, res4]) => Promise.all([res1.json(), res2.json(), res3.json(), res4.json()]))
        .then(([data1, data2, data3, data4]) => {
            let initialData = {};
            initialData['data1'] = data1;
            initialData['data2'] = data2;
            initialData['data3'] = data3;
            initialData['data4'] = data4;
            dispatch(receivedData(initialData))
        }).catch(err => dispatch(dataError(err)));
};

export const fetchInitialData5 = (obj1, obj2, obj3, obj4, obj5, header) => (dispatch, getState) => {
    console.log("request data 1 : ", obj1.body);
    console.log("request data 2 : ", obj2.body);
    console.log("request data 3 : ", obj3.body);
    console.log("request data 4 : ", obj4.body);
    console.log("request data 5 : ", obj5.body);
    dispatch(requestData());
    return Promise.all([
        fetch(obj1.url, {
            method: 'POST',
            body: obj1.body,
            headers: JSON.parse(header)
        }),
        fetch(obj2.url, {
            method: 'POST',
            body: obj2.body,
            headers: JSON.parse(header)
        }),
        fetch(obj3.url, {
            method: 'POST',
            body: obj3.body,
            headers: JSON.parse(header)
        }),
        fetch(obj4.url, {
            method: 'POST',
            body: obj4.body,
            headers: JSON.parse(header)
        }),
        fetch(obj5.url, {
            method: 'POST',
            body: obj5.body,
            headers: JSON.parse(header)
        })
    ]).then(([res1, res2, res3, res4, res5]) => Promise.all([res1.json(), res2.json(), res3.json(), res4.json(), res5.json()]))
        .then(([data1, data2, data3, data4, data5]) => {
            let initialData = {};
            initialData['data1'] = data1;
            initialData['data2'] = data2;
            initialData['data3'] = data3;
            initialData['data4'] = data4;
            initialData['data5'] = data5;
            dispatch(receivedData(initialData))
        }).catch(err => dispatch(dataError(err)));
};
